import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`w-10 h-10 rounded-full flex items-center justify-center text-stone-500 dark:text-stone-300 bg-stone-50 dark:bg-stone-800 hover:bg-stone-100 dark:hover:bg-stone-700 transition-all ${className}`}
    >
      {theme === 'dark' ? (
        <i className="fas fa-sun text-sm"></i>
      ) : (
        <i className="fas fa-moon text-sm"></i>
      )}
    </button>
  );
};

export default ThemeToggle;
